export function podcast_carousel() {

  let episode_carousel = $('.episode-carousel');
  let align;

  console.log('what is episode carousel', episode_carousel);

  if(window.innerWidth > 980) {
    align = "left"; 
  } else if(window.innerWidth < 980) {
    align = "left";
  }

  window.addEventListener('resize', function(){
    if(window.innerWidth > 980) {
      align = "center";
    } else if(window.innerWidth < 980){
      align = "center";
    }
  });

  if(episode_carousel != null) {
    console.log('helllloo');
    $(episode_carousel).flickity({
      pageDots: false,
      cellAlign: align,
      draggable: true,
      groupCells: false,
      wrapAround: false,
      resize: true,
      freeScroll: true
    });
  }
}